import type { ReactNode } from 'react'
import { CheckboxControl } from '@systemeio/components'
import { Trans } from 'next-i18next/pages'
import { ACTIVITY_CLEANUP_PERIOD_DURATION } from 'modules/community/const/post-consts'
import { useCommunityWithTopics } from 'modules/community/hooks/use-community-with-topics'
import type { MemberInterface } from 'modules/community/types/member-interface'

interface RemoveRecentActivitiesCheckbox {
  label?: string
  memberDisplayName?: MemberInterface['displayName']
  checked: boolean
  onCheck: (value: boolean) => void
}

export const RemoveRecentActivitiesCheckbox = ({
  label,
  memberDisplayName,
  checked,
  onCheck,
}: RemoveRecentActivitiesCheckbox): ReactNode => {
  const { data: community } = useCommunityWithTopics()

  return (
    <div className="flex flex-col justify-start gap-2">
      {label && <p>{label}</p>}
      <div className="mt-2 flex items-start [&>label]:items-start">
        <CheckboxControl
          label={
            <Trans
              i18nKey={'settings.form.ban_user_delete_recent_activity_label'}
              values={{
                days: ACTIVITY_CLEANUP_PERIOD_DURATION,
                member: memberDisplayName,
                community: community?.name,
              }}
            />
          }
          checked={checked}
          onCheckedChange={onCheck}
        />
      </div>
    </div>
  )
}
